import { useEffect, useState } from "react";
import { Component } from "react";
import Lenis from "lenis";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import Modules from "@/components/Modules";
import Schedule from "@/components/Schedule";
import ForYou from "@/components/ForYou";
import FinalCTA from "@/components/FinalCTA";
import RegistrationSection from "@/components/RegistrationSection";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";
import PrivacyPolicy from "@/components/PrivacyPolicy";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#08060D] text-white font-body">
          <p>Something went wrong. Sila muat semula halaman.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const useHashRoute = () => {
  const [route, setRoute] = useState(window.location.hash);
  useEffect(() => {
    const onHash = () => setRoute(window.location.hash);
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);
  return route;
};

function App() {
  const route = useHashRoute();
  const isPrivacy = route.startsWith("#/privacy-policy");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isPrivacy]);

  // Meta Pixel dimuatkan dalam <head> (public/index.html):
  // PageView semasa halaman dibuka, event custom "TelegramClick"
  // hanya apabila butang Telegram diklik, dan "CompleteRegistration"
  // hanya selepas borang pendaftaran berjaya dihantar (src/config.js).

  if (isPrivacy) {
    return (
      <ErrorBoundary>
        <div className="relative overflow-x-clip bg-ink font-body text-white antialiased">
          <Navbar />
          <PrivacyPolicy />
          <Footer />
        </div>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <div className="relative overflow-x-clip bg-ink font-body text-white antialiased">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Problem />
          <Modules />
          <Schedule />
          <ForYou />
          <FinalCTA />
          <RegistrationSection />
          <FAQ />
        </main>
        <Footer />
        <StickyCTA />
      </div>
    </ErrorBoundary>
  );
}

export default App;
